import { RenderUniqueGlassProps } from "../interface";

export const renderUniqueGlassOptions = ({
    glassSizes,
    selectedSize,
    handleProductId,
    outOfStock,
    singleColor,
}: RenderUniqueGlassProps) => {
    const uniqueGlassSizes = Array.from(
        new Map(glassSizes?.map((item) => [item.glass_size, item])).values()
    );

    return (
        <>
            {uniqueGlassSizes?.map((item, index) => (
                <p
                    className="glass-div cursor-pointer fw-700 fs-md-18 fs-12 my-auto"
                    key={`glass${index}`}
                    style={{
                        borderColor: selectedSize === item.glass_size ? "#05b7e4" : "black",
                        backgroundColor:
                            selectedSize === item.glass_size ? "#05b7e4" : "#fff",
                        color: selectedSize === item.glass_size ? "#fff" : "black",
                    }}
                    onClick={() => handleProductId(item.product_id)}
                >
                    {item.glass_size}
                </p>
            ))}
            {outOfStock &&
                singleColor &&
                !uniqueGlassSizes.some(
                    (item) => item.glass_size === singleColor.glass_size
                ) && (
                    <p
                        className="glass-div cursor-pointer fw-700 fs-md-18 fs-12 my-auto"
                        key={`glass`}
                        style={{
                            borderColor:
                                selectedSize === singleColor.glass_size ? "#05b7e4" : "black",
                            backgroundColor:
                                selectedSize === singleColor.glass_size ? "#05b7e4" : "#fff",
                            color: selectedSize === singleColor.glass_size ? "#fff" : "black",
                        }}
                        onClick={() => handleProductId(singleColor.id)}
                    >
                        {singleColor.glass_size}
                    </p>
                )}
        </>
    );
};
